"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconInbox = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M21,3 L3.01,3 L3.01,21 L21,21 L21,3 Z M19,15 L15,15 C15,16.66 13.65,18 12,18 C10.35,18 9,16.66 9,15 L5,15 L5,5 L19,5 L19,15 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconInbox')(IconInbox);